import React from 'react';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import { useCalendarManager } from '../../../../services/queries/calendar';
import styles from './index.module.scss';

const { calendarPage: pageKey, calendarMode: modeKey } = searchParamKeys;

const CalendarMonthTitle = () => {
  const page = useSearchParamsSelector((state) => {
    return Number(state[pageKey]);
  });

  const mode = useSearchParamsSelector(searchParamSelectors[modeKey]);

  const calendarManager = useCalendarManager();

  const dates = calendarManager.getDates(mode, page);

  if (!dates.length) return null;

  const [first] = dates[0];
  const [last] = dates[dates.length - 1];

  const title = first.isSame(last, 'month')
    ? first.format('MMMM')
    : `${first.format('MMM')} - ${last.format('MMM')}`;

  return <span className={styles.root}>{title}</span>;
};

export default CalendarMonthTitle;
